import _ from 'lodash'
import API_HINT_CONFIG from './config'

class ApiHintClass {
    constructor() {
        this.DOM = {
            hint: API_HINT_CONFIG.hint,
            closer: API_HINT_CONFIG.closer,
            message: API_HINT_CONFIG.message
        }

        this.timeout = API_HINT_CONFIG.timeout
        this.error = this.DOM.hint.getAttribute( 'data-message-error' )
        this.DOM.hint ? this.init() : null
    }

    init() {
        this._listeners()
    }

    _listeners() {
        this.DOM.closer.addEventListener( 'click', this._close.bind( this, 0 ) )
    }

    _open( state, message ) {
        _.addClass( this.DOM.hint, state )
        this.DOM.message.innerHTML = message
    }

    _close( timeout = this.timeout  ) {
        setTimeout( () => {
            _.removeClass( this.DOM.hint, 'is--success' )
            _.removeClass( this.DOM.hint, 'is--error' )
        }, timeout )
    }
}

const API_HINT = new ApiHintClass()
export default API_HINT